module.exports = __webpack_public_path__ + "static/media/MenuBeverage.7da67c10.jpg";